import React from 'react';

import { formatDate } from '@repo/util/formatDate';
import { ResultOf } from '@graphql-typed-document-node/core';

import { Tabs } from '@repo/ui/Tabs';
import { TabDataCard } from '@repo/ui/Tabs';
import { DataCardGroup } from '@repo/ui/Tabs';

import MMS_SHOW_Q from '../gql/mmsRequest_show.gql';

import { useUser } from '@repo/hooks/useUser';
import { POLICIES } from '@/lib/Authorization';

export type SmsOverviewPropsData = ResultOf<typeof MMS_SHOW_Q>;

export interface SmsOverviewProps {
  data: SmsOverviewPropsData;
  error?: Error | undefined;
  loading: boolean;
}

const SmsOverview = ({ data, error, loading }: SmsOverviewProps) => {
  const user = useUser();

  const MmsOverviewData: DataCardGroup[] = [
    {
      groupTitle: 'account',
      columnCount: 3,
      groupData: [
        {
          label: 'Account',
          entry: POLICIES['accounts:show'](user) ? (
            <a
              className="underline transition-colors hover:dark:text-blue-300"
              href={`/a/${data?.mmsRequest.account.id}`}
            >
              {data?.mmsRequest.account.name}
            </a>
          ) : (
            <span>{data?.mmsRequest.account.name}</span>
          ),
        },
        {
          label: 'ID',
          entry: data?.mmsRequest.id,
        },
        {
          label: 'Created at',
          entry: !loading && formatDate(data?.mmsRequest.insertedAt),
        },
        {
          label: 'Sent at',
          entry: !loading && formatDate(data?.mmsRequest.processedAt),
        },
        {
          label: 'Delivered at',
          entry: !loading && formatDate(data?.mmsRequest.updatedAt),
        },
      ],
    },

    {
      groupTitle: 'status',
      columnCount: 4,
      groupData: [
        {
          label: 'Status',
          entry: data?.mmsRequest.status,
        },

        {
          label: 'Status code',
          entry: data?.mmsRequest.errorCode,
        },
      ],
    },

    {
      groupTitle: 'body',
      columnCount: 1,
      groupData: [
        {
          label: 'Body',
          entry: data?.mmsRequest.displayBody,
        },
      ],
    },
  ];

  const MmsDeliveryData: DataCardGroup[] = [
    {
      groupTitle: 'delivery',
      columnCount: 3,
      groupData: [
        {
          label: 'Direction',
          entry: data?.mmsRequest.direction,
        },
        {
          label: 'Host number',
          entry: data?.mmsRequest.hostNumber,
        },
        {
          label: 'Remote number',
          entry: data?.mmsRequest.remoteNumber,
        },
        {
          label: 'Destination carrier',
          entry: data?.mmsRequest.remoteReferenceId,
        },
      ],
    },
  ];

  const SmsTabs = [
    {
      title: 'Overview',
      contents: <TabDataCard title="Overview" loading={loading} data={MmsOverviewData} />,
    },
    {
      title: 'Delivery',
      contents: <TabDataCard title="Delivery" loading={loading} data={MmsDeliveryData} />,
    },
  ];

  return <Tabs tabs={SmsTabs} loading={loading} error={error} />;
};

export default SmsOverview;
